// Risk or Legal sends a counterparty back to an earlier gate, saying why (TX-US-0042). Legal
// chooses which: Compliance, or Risk when a credit review that was skipped is needed after all. A
// return is not a rejection - the counterparty stays in onboarding.

import { useState } from 'react';

import { transitionCounterparty } from '../../api.js';
import { GATE_OWNERS, statusLabel } from '../labels.js';
import MoveDialog, { ReasonField } from '../../ui/MoveDialog.jsx';
import { moveRefusal } from './path.js';

const toOwner = (status) => GATE_OWNERS[status].charAt(0) + GATE_OWNERS[status].slice(1).toLowerCase();

export default function ReturnDialog({ counterparty, targets, onClose, onMoved }) {
  const [target, setTarget] = useState(targets[0]);
  const [reason, setReason] = useState('');

  return (
    <MoveDialog
      refusal={moveRefusal}
      title={`Return ${counterparty.name}?`}
      hint="It goes back to the gate you choose, with your reason, and that gate's owner is told."
      submitLabel={`Return to ${toOwner(target)}`}
      busyLabel="Returning…"
      ready={Boolean(reason.trim())}
      move={() => transitionCounterparty(
        counterparty.counterparty_id, target, counterparty.version, reason.trim(),
      )}
      onClose={onClose}
      onMoved={onMoved}
    >
      {targets.length > 1 && (
        <fieldset className="choice-set">
          <legend>Return to</legend>
          {targets.map((code) => (
            <label key={code} className="choice">
              <input type="radio" name="return-target" value={code} checked={target === code}
                     onChange={() => setTarget(code)} />
              {toOwner(code)} ({statusLabel(code)})
            </label>
          ))}
        </fieldset>
      )}
      <ReasonField value={reason} onChange={setReason} />
    </MoveDialog>
  );
}
